// react imports
import { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// material-ui imports
import { Stack, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTheme } from '@mui/material/styles';

// third-party imports
import { useIntl } from 'react-intl';
import { isEqual } from 'lodash';

// project imports
import { changeFileMngrItemName } from '..';

// ==============================|| PATH BREADCRUMB ||============================== //

/**
 * Path Breadcrumb component
 * @author Marcos L. A. Soto <marcosleonildo@gmail.com>
 * @param {array} path - path array
 * @param {array} currentPath - current path array
 * @param {function} handleReadFolder - read folder function
 * @param {boolean} workWithTemp - define temp folder usage
 * @returns {JSX.Element}
 */

const FileMngrPathBreadcrumb = ({ path = [], currentPath = [], handleReadFolder, workWithTemp = false }) => {
    const intl = useIntl();
    const theme = useTheme();

    const [localCurrentPath, setLocalCurrentPath] = useState(currentPath ?? []);

    const convertToStrPath = (arrayPath) =>
        `/${arrayPath
            .slice(1)
            .map((item) => item.name)
            .join('/')
            .replace('//', '/')}`;

    const handleClick = async (index) => {
        if (localCurrentPath && Array.isArray(localCurrentPath)) {
            const updatedPath = localCurrentPath.slice(0, index + 1);

            await handleReadFolder(convertToStrPath(updatedPath));
        }
    };

    useEffect(() => {
        if (!isEqual(localCurrentPath, currentPath)) {
            setLocalCurrentPath(currentPath);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPath]);

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{
                [theme.breakpoints.down('md')]: {
                    overflowX: 'auto'
                }
            }}
        >
            {localCurrentPath.map((item, index) => (
                <Fragment key={index}>
                    <Typography
                        // title={workWithTemp && index === 0 ? intl.formatMessage({ id: 'ui-comp-filemngr-temporaryfolder' }) : item.name}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => handleClick(index)}
                    >
                        {workWithTemp && index === 0
                            ? intl.formatMessage({ id: 'ui-comp-filemngr-temporaryfolder' })
                            : changeFileMngrItemName(item?.name, intl)}
                    </Typography>
                    {index < path.length - 1 && <NavigateNextIcon />}
                </Fragment>
            ))}
        </Stack>
    );
};

FileMngrPathBreadcrumb.propTypes = {
    path: PropTypes.array,
    currentPath: PropTypes.array,
    handleReadFolder: PropTypes.func,
    workWithTemp: PropTypes.bool
};

export default FileMngrPathBreadcrumb;
